import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useFarmId } from '~/common/use-farm-id'
import { supabaseGetter } from '~/api/supabase-getter'
import { FarmMembersCard } from './farm-members-card'
import { FarmMapsCard } from './farm-maps-card'
import { FarmClimateCard } from './farm-climate-card'
import { useFeatures } from '~/common/use-features'

export const FarmPreferencesSection = () => {
  const { farmId } = useFarmId()
  const [climate, setClimate] = useState(null)
  const [loading, setLoading] = useState(false)
  const { features } = useFeatures()

  useEffect(() => {
    async function fetchClimate() {
      if (!farmId) { setClimate(null); return }
      setLoading(true)
      const { data, error } = await supabaseGetter.climates.getByOrganization(farmId)
      if (!error && data) setClimate(data)
      setLoading(false)
    }
    fetchClimate()
  }, [farmId])

  if (!farmId) {
    return null
  }

  if (loading) {
    return (
      <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  return (
    <>
      <Typography variant="h5" sx={{ mb: 2 }}>Farm Preferences</Typography>
      
      <Stack spacing={2}>
        <FarmMembersCard farmId={farmId} />
        <FarmMapsCard climate={climate} />
        {features['edit_farm'] && (
          <FarmClimateCard key={climate?.id} initialClimate={climate} />
        )}
      </Stack>
    </>
  )
}
